// Backend-aligned types matching GraphQL schema exactly

export enum AccountType {
    STANDALONE = 'STANDALONE',
    ROOT = 'ROOT',
    MANAGED = 'MANAGED'
}

export enum AccountStatus {
    ACTIVE = 'ACTIVE',
    SUSPENDED = 'SUSPENDED'
}

export enum OrganizationAccountStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE'
}

// Backend Account schema (NO organizationId field)
export type Account = {
    id: string,
    sub: string,           // Cognito user ID
    username?: string,
    email: string,
    accountType: AccountType,
    accountStatus?: AccountStatus,
    customerId?: string,   // Billing reference
    created?: string,
    updated?: string,
    // Frontend-only fields (not in GraphQL schema)
    name?: string,         // Computed from username or email
}

// Organization type (defined before OrganizationAccount to avoid circular reference)
export type Organization = {
    id: string,
    name: string,
    description?: string,
    adminAccountId?: string,
    adminAccount?: Account,  // 1:1 relationship
    url?: string,
    email?: string,
    phone?: string,
    createdByUsername?: string,
    created?: string,
    updated?: string,
}

// Junction table for Organization-Account M:N relationship
export type OrganizationAccount = {
    id: string,
    organizationId: string,
    accountId: string,
    account?: Account,     // Nested for GraphQL
    organization?: Organization,
    organizationAccountStatus?: OrganizationAccountStatus,
    createdByUsername?: string,
    created?: string,
    updated?: string,
}

// GraphQL Response Types
export type AccountConnection = {
    items: Account[],
    nextToken?: string
}

export type OrganizationAccountConnection = {
    items: OrganizationAccount[],
    nextToken?: string
}

export type OrganizationConnection = {
    items: Organization[],
    nextToken?: string
}